import React from "react";
import Hero from "../../components/sections/Home/Hero";
import About from "../../components/sections/Home/About";
import TotalPrize from "../../components/sections/Home/TotalPrize";
import Podium from "../../components/sections/Home/Podium";
import Sponsor from "../../components/sections/Home/Sponsor";

export default function AlternateHome() {
    return (
        <>
            {/* <div className="w-full h-[60vh] md:min-h-screen bg-comingSoonBanner bg-contain 2xl:bg-cover bg-center bg-no-repeat"></div> */}
            <Hero />
            {/* <About /> */}
            {/* <Podium />
            <TotalPrize />
            <Sponsor /> */}

        </>
    );
}
